import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CarouselComponent } from "./carousel/carousel.component";
import {BrandsComponent} from "./brands/brands.component";
import {ProductComponent} from "./product/product.component";
import {AddressesComponent} from "./addresses/addresses.component";
import {ManageAddressComponent} from "./addresses/manage-address/manage-address.component";
import {DialogModule} from "primeng/dialog";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {ConfirmDialogModule} from "primeng/confirmdialog";
import {TopFilterComponent} from "./top-filter/top-filter.component";
import {SidebarModule} from "primeng/sidebar";
import {GalleriaModule} from "primeng/galleria";
import {CarouselModule} from "primeng/carousel";
import {SectionComponent} from "./section/section.component";
import {ButtonModule} from "primeng/button";
import {ImagesComponent} from "./section/images/images.component";

@NgModule({
  declarations: [
    CarouselComponent,
    BrandsComponent,
    ProductComponent,
    AddressesComponent,
    ManageAddressComponent,
    TopFilterComponent,
    SectionComponent,
    ImagesComponent,
  ],
  exports: [
    CarouselComponent,
    BrandsComponent,
    ProductComponent,
    AddressesComponent,
    ManageAddressComponent,
    TopFilterComponent,
    SectionComponent,
    ImagesComponent
  ],
    imports: [
        CommonModule,
        RouterModule,
        CarouselModule,
        DialogModule,
        FormsModule,
        ReactiveFormsModule,
        ConfirmDialogModule,
        SidebarModule,
        GalleriaModule,
        ButtonModule,
    ]
})
export class ComponentsModule { }
